<template>
	<div class="module_course page_content" aria-label="Entity Result Page Content" :class="addPrintClass()">

    <course-header ref="courseHeader" :course-id="course.uuid" :entityUuid="entity.uuid" class="header_entity_result"></course-header>
  		<div class="row page-content content_entity_result" :class="isTocOpen ? 'toc_activated' : ''">
        <template v-if="allDataLoaded">
          <div class="col-12 can_full_screen" aria-label="Entity Result Section" style="overflow-y: scroll;">

    				<div class="header">
  						<!--
  						<div class="header-view"></div>
  						-->
    					<span v-if="entity.fileType === 'assessment'" class="icon icon-assessment"></span>
              <span v-if="entity.fileType === 'video'" class="icon icon-video"></span>
              <span v-if="entity.fileType === 'scorm'" class="icon icon-scorm"></span>
    					<span v-if="entity.fileType === 'pdf'" class="icon icon-file-pdf"></span>
    					<span v-if="entity.fileType === 'doc' || entity.fileType === 'docx'" class="icon icon-file-word"></span>
    					<span v-if="entity.fileType === 'xlsx'" class="icon icon-file-excel"></span>
    					<span v-if="entity.fileType === 'html'" class="icon icon-pageURL"></span>
    					<span v-if="entity.fileType === 'jpg' || entity.fileType === 'jpeg' || entity.fileType === 'png' || entity.fileType === 'gif'" class="icon icon-image"></span>
    				  <span class="heading ace_sec_hd">{{entity.title}} <span v-if="entity.type === 'ASSESSMENT'"> - Result</span></span>

  						<div class="btn_container entity_result_btns">
								<full-screen-method :action="'clickFullScreenResource'"></full-screen-method>
  							<b-button v-if="entity" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: entity.objectType, entityUuid: entity.uuid, action: 'clickCourseTraversePrev' } }" class="btn button-primary pre" aria-label="previous">
									<span class="btn_txt">prev</span>
								</b-button>
                <template v-if="toBeLocked" >
                <b-button :disabled="nextEntity.title ==='COURSE_FINISHED'" v-if="nextEntity" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: nextTOCType, entityUuid: nextTOCUuid, action: 'clickCourseTraverseNext' , locked:toBeLocked} }" class="btn button-primary next" aria-label="next">
                  <span class="btn_txt">next</span>
                </b-button>
                </template>
                <template v-else-if="(( (nextEntity.ancestor===entity.ancestor ) ||  !(course.includeCDesc || course.includeCAI )))" >
                <b-button :disabled="nextEntity.title ==='COURSE_FINISHED'" v-if="nextEntity" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: nextEntity.objectType, entityUuid: nextEntity.uuid, action: 'clickCourseTraverseNext' } }" class="btn button-primary next" aria-label="next">
									<span class="btn_txt">next</span>
								</b-button>
                </template>
                <template v-else>
                <b-button :disabled="nextEntity.title ==='COURSE_FINISHED'" v-if="nextEntity" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: nextTOCType, entityUuid: nextTOCUuid, action: 'clickCourseTraverseNext' } }" class="btn button-primary next" aria-label="next">
                  <span class="btn_txt">next</span>
                </b-button>
                </template>
              </div>
  					</div>
             <div>
                <b-modal id="logicModalContainer" class="modal__v22_2" ref="logicModal"  size="md" hide-footer no-close-on-backdrop no-close-on-esc centered>

									<div slot="modal-header" class="w-100">
		      					<div class="row">
		      						<div class="col-2 hd">
		      							<div class="ic_container">

		      							</div>
		      						</div>
		                  <div class="col-8 hd">
		      							<div class="hd_txt text-center w-100" style="margin-left: 0px;">
		      								<span>{{competencyLogic.messageTitle}}</span>
		      							</div>
		      						</div>
		      						<div class="col-2 btn_container">
		      							<button class="btn_close" aria-label="close" title="close the popup" @click="closeComptencyLogicModal">
		      								<span class="ic-close"></span>
		      							</button>
		      						</div>
		      					</div>
		      				</div>

									<!--
									<div class="row entity_head">
                    <div class="col-12">
                      <div class="hd_txt">
                        {{competencyLogic.messageTitle}}
                      </div>
                    </div>
                  </div>
									-->
                  <div class="row modal_msg_container">
                    <div class="col-11 msg_sec" v-html="competencyLogic.message">
                    </div>
                  </div>
                </b-modal>
              </div>

    				<div class="entity-content-section row">
              <template v-if="isEntityActivityLoaded">
                <!-- REMOVE SHOWING TIME TAKEN
        					<div  v-if="entity.type === 'ASSESSMENT'" class="time_taken ace_sec_txt">
                    Time spent on {{entity.title}} is <strong>{{msToTime(entityActivity.assessmentTimeTaken)}}</strong>
                  </div>
                  <div  v-else class="time_taken ace_sec_txt">
                    Time spent on {{entity.title}} is <strong>{{msToTime(entityActivity.resourceTimeTaken)}}</strong>
                  </div>
                -->
                <div  v-if="entity.type !== 'ASSESSMENT'" class="time_taken ace_sec_txt">
                  Great! You completed {{entity.title}}. Keep going!
                </div>
                <div v-if="entity.objectType === 'LearningContent'" class="float-left w-100">
      						<div v-if="entity.type === 'ASSESSMENT'" class="mt-2 entity_result">
      						  <template v-if="isEntityDetailLoaded">
      							<assessment-detail :uuid ="entity.uuid" :course-id="course.uuid"></assessment-detail>
      						  </template>
      						</div>
      						<div v-else>
      						</div>
      					</div>
              </template>
              <div class="col-11 pg_sec_bx">
								<div class="pg_sec_bx_hd">
									Next Step
								</div>
                <div class="pg_sec_bx_inner" v-if="toBeLocked">
                      <span v-if="lockedTopic.unlockReliantOnType==4">
                        Next Micro Competency "{{lockedTopic.title}}" is locked because you have not completed the previous Competency! <br/><br/>
                        Please complete all the Micro Competency in "{{lockedTopic.unlockReliantOnTitle[0]}}" to access this.
                      </span>
                      <span v-if="lockedTopic.unlockReliantOnType==5">
                        Next Micro Competency "{{lockedTopic.title}}" is locked because you have not completed the previous Micro Competency! <br/> <br/>
                        Please complete  "{{lockedTopic.unlockReliantOnTitle[0]}}" Micro Competency to access this.
                      </span>
                      <span v-if="lockedTopic.unlockReliantOnType==3">
                        Next Micro Competency is locked because you have not completed the Diagnostic Test! <br/><br/>
                        Please complete Diagnostic Test "{{lockedTopic.unlockReliantOnTitle[0]}}" to access this.
                      </span>
                      <span  v-if="lockedTopic.unlockReliantOnType==2">
                        Next Micro Competency will open on "{{lockedTopic.unlockReliantOnTitle[0]}}".
                      </span>                    
                      <span  v-if="lockedTopic.unlockReliantOnType==1">
                        Next Micro Competency will open when "{{lockedTopic.unlockReliantOnTitle[0]}}".
                      </span>                    
                </div>
    						<div class="pg_sec_bx_inner" v-if="!toBeLocked">
    	            <template v-if="isEntityActivityLoaded && entity.type === 'ASSESSMENT'">
    	              <div v-html="kCMessage"></div>
    	            </template>
    	            <!-- Next Entity Details -->
    	            <div v-if="isNextEntityDetailLoaded && ( (nextEntity.ancestor===entity.ancestor ) ||  !(course.includeCDesc || course.includeCAI ))">

    	      					<div v-if="nextEntity.title !== 'COURSE_FINISHED' && nextEntity.title !== 'KC_SUBMITTED'">
    	      						<div class="entity-content-section">
    	                    <div class="description mb-3 ace_sec_txt"><strong>{{nextEntity.title}}</strong></div>
    	      							<div v-if="nextEntity.type !== 'ASSESSMENT'" v-html="nextEntity.description" class="description mb-3 ace_sec_txt"></div>
    	      							<div v-if="nextEntity.objectType === 'LearningContent'" class="float-left w-100">
    	                                      <template v-if="((course.courseType === 'RICH_HTML_SUPPORT') && (nextEntity.type === 'RICH_HTML'))">
    	                                          <rich-html-launch-assessment :resource-id="nextEntity.uuid" :html="nextEntity.htmlBody" :course-id="course.uuid" @afterRender="afterRenderRichHtml" :container-class="'rich-html-container'"></rich-html-launch-assessment>
    	                                      </template>
    	                                      <template v-else>
    	          							  	<div v-if="nextEntity.type === 'ASSESSMENT'" class="mt-3">
    	          									<assessment-detail :uuid ="nextEntity.uuid" :course-id="course.uuid" :doNotShowOutcome="true"></assessment-detail>
    	          							  	</div>
    	          							  	<div v-else>
    	          									<b-button :to="{ name: 'entityLearn', params: { uuid: course.uuid, entityType: nextEntity.objectType, entityUuid: nextEntity.uuid } }" variant="primary" size="lg" class="btn_lg" aria-label="Start Learning">Start Learning</b-button>
    	          							  	</div>
    	      							  	</template>
    	      							</div>

    	      						</div>
    	      					</div>


    	      					<div v-if="nextEntity.title === 'COURSE_FINISHED'">
    	      						<div class="col-12 navigate-to-dashboardPage">

    	      							<div class="success-msg ace_sec_txt">
    	      								You’ve finished the course <i>{{ course.title }}</i>
    	      							</div>

    	      							<!--
    	      							<div class="result-wrapper">
    	      								<div class="result-row row">
    	      									<div class="result-label"> Final Score - </div>
    	      									<div class="result-value" id="prog_val"></div>
    	      								</div>

    	      								<div class="result-row row">
    	      									<div class="result-label"> Time Taken - </div>
    	      									<div class="result-value">  4 Weeks </div>
    	      								</div>

    	      								<div class="result-row row">
    	      									<div class="result-label"> Competencies Completed - </div>
    	      									<div class="result-value">  16 of 16 </div>
    	      								</div>
    	      							</div>
    	      							-->

    	      							<div class="more-details" style="margin-top: 60px;">
    	      								<p class="ace_sec_txt">For more details go to the course dashboard.</p>
    	      							</div>
    	      							<div class="w-100 d-flex justify-content-center">
    	      								<b-button :to="{ name: 'courseDashboard', params: { uuid: course.uuid} }" variant="primary" size="lg" class="btn_lg mb-4 mt-2" aria-label="Go to Dashboard">Go to Dashboard</b-button>
    	      							</div>

    	      						</div>
    	      					</div>



    	      					<div v-if="nextEntity.title === 'KC_SUBMITTED'">
    	      						<div class="col-12 navigate-to-dashboardPage">

    	      							<div class="success-msg ace_sec_txt">
    	      								You’ve successfully submitted the quest. Please wait for next action from your coach. <br/><br/><br/><b>
    	                      Once the next quest is available you will be notified via email.</b>
    	      							</div>

    	      						</div>
    	      					</div>


                  </div>
                  <div v-else>
                       <template v-if="nextCTitle && nextMCTitle" >
                       Let’s move to the next Topic : {{nextCTitle}} starting with sub topic {{nextMCTitle}}
                       </template>
                       <template v-else>
                       <template v-if="nextCTitle" >
                       Let’s move to the next Topic : {{nextCTitle}}
                       </template>
                       <template v-if="nextMCTitle" >
                       Let’s move to the next Topic : {{nextMCTitle}}
                       </template>
                       </template>

                  </div>

    	            <!-- Next Entity Details Ends -->
    	        	</div>
    					</div>


    					<!--<div v-html="entity.description" class="description float-left w-100 mb-3 ace_sec_txt"></div>-->




    				</div>


  			</div>
        </template>
        <stretch class="loader_v23" v-if="!allDataLoaded"></stretch>
  		</div>

			<div class="print_msg">
				Print is not available
			</div>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CourseHeader from './CourseHeader'
import CourseNav from './CourseNav'
import TOC from './TOC'
import AssessmentDetail from '../../assessment/components/AssessmentDetail'
import RichHtmlLaunchAssessment from '../../assessment/components/RichHtmlLaunchAssessment'
import fullScreenMethod from '../../common/components/fullScreenMethod'
//import { Stretch } from 'vue-loading-spinner'

export default {
  name: 'entity-result',
  props: ['uuid', 'entityType', 'entityUuid'],
  components: {
    CourseHeader,
    CourseNav,
    TOC,
    AssessmentDetail,
    RichHtmlLaunchAssessment,
    fullScreenMethod,
    //Stretch
  },
  data: () => {
    return {
      isEntityDetailLoaded: false,
      isNextEntityDetailLoaded: false,
      isEntityActivityLoaded: false,
      kCMessage: '',
      nextTOCUuid:'',
      nextTOCType:'',
      nextCTitle:'',
      toBeLocked: false,
      lockedTopic: {},
      nextCOrder:'',
      nextMCTitle:'',
      competencyLogicMap : {},
      competencyLogic : {},
      allDataLoaded: false
    }
  },

  mounted () {
    this.loadCourse()
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadEntityDetail',
      'loadCourseTopics',
      'loadEntityActivity',
      'loadNextEntityDetail',
      'stopActivity',
      'loadCompetencyLogic',
      'loadKCMessage'
    ]),

    async loadCourse () {
      var entityDetailInfo = {
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      var nextEntityDetailInfo = {
        'courseUuid': this.uuid,
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      var entityActityInfo = {
        'courseUuid': this.uuid,
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }

      let res2 = await this.loadEntityDetail(entityDetailInfo)
      if (res2 && res2.type === 'ASSESSMENT') {
        this.isEntityDetailLoaded = true
        var stopActivity = {
          'userId': localStorage.getItem('userid'),
          'entityUuid': this.entityUuid,
          'rating': '0'
        }
        this.stopActivity(stopActivity)
        this.loadKCMessage({entityId: this.entityUuid, courseType: this.course.courseType}).then(kCRes => {
          this.kCMessage = kCRes
        })
      }

      let res = await this.loadNextEntityDetail(nextEntityDetailInfo)
      if (res) {
        console.log('Next Entity:', res)
        console.log('Next Entity State:', this.nextEntity)
        this.isNextEntityDetailLoaded = true
        if (res.title === 'CONVERSATION_SUBMITTED') {
          return this.$router.push({ name: 'connection', params: {careerIdeaId: res.uuid} })
        }
      }
      if(this.nextEntity.ancestor!==this.entity.ancestor){
        await this.loadCourseTopics({uuid: this.uuid, loadDataFromServer: true})
      }
      if(this.nextEntity.ancestor!==this.entity.ancestor){
        for (var i = 0; i < this.linearTopics.length; i++) {
          if (this.linearTopics[i].uuid === this.entityUuid) {
            for (var j = i + 1; j < this.linearTopics.length; j++) {
              if(this.nextEntity.ancestor === this.linearTopics[j].uuid){
                if(this.linearTopics[j].locked){
                  this.nextTOCUuid = this.linearTopics[j].uuid
                  this.nextTOCType = this.linearTopics[j].objectType
                  this.lockedTopic = this.linearTopics[j]
                  this.toBeLocked = true
                  break              
                }
              }
              if(this.course.includeCAI || this.course.includeCDesc){
                  if (this.linearTopics[j].objectType === 'LearningTopic') {
                    if(this.entity.diagonesticTest && this.linearTopics[j].uuid !== this.nextEntity.ancestor){
                        continue
                    }
                    this.nextTOCUuid = this.linearTopics[j].uuid
                    this.nextTOCType = this.linearTopics[j].objectType
                  // Next Topic C to C - C, MC to MC - MC
                  if(this.nextEntity.ancestor === this.nextTOCUuid){
                    this.nextMCTitle = this.linearTopics[j].title
                    this.nextCTitle = ''
                    this.nextCOrder = this.linearTopics[j].orderId
                  }else{
                    this.nextCTitle = this.linearTopics[j].title
                    this.nextCOrder = this.linearTopics[j].orderId
                    if(this.linearTopics[j+1] && this.nextEntity.ancestor===this.linearTopics[j+1].uuid){
                      this.nextMCTitle = this.linearTopics[j+1].title
                    }
                  }
                  break
                }
              }
            }
          }
        }
      }
      await this.loadCourseDetail(this.uuid)
      let resActivity = await this.loadEntityActivity(entityActityInfo)
      if (resActivity) {
        this.isEntityActivityLoaded = true
      }
      if (this.nextEntity.type === 'SCORM') {
        return this.$router.push({ name: 'entityDetail', params: { uuid: this.course.uuid, entityType: this.nextEntity.objectType, entityUuid: this.nextEntity.uuid } })
      }
      if (this.nextTOCType !== 'LearningTopic' && this.nextEntity.type !== 'ASSESSMENT' && this.entity.type !== 'ASSESSMENT' && this.nextEntity.title !== 'COURSE_FINISHED') {
        return this.$router.push({ name: 'entityLearn', params: { uuid: this.course.uuid, entityType: this.nextEntity.objectType, entityUuid: this.nextEntity.uuid } })
      }
      this.allDataLoaded = true
      if(this.course.includePostMessage){
          this.competencyLogicMap = await this.loadCompetencyLogic({courseId:this.course.uuid, type:'POST'})
          if(this.nextEntity.ancestor!==this.entity.ancestor){
              // Moving to next C/MC
              // get the current object ancestor Message
              let currentCompetencyid = this.getParentCompetencyId(this.entity.ancestor)
              this.competencyLogic = this.competencyLogicMap[currentCompetencyid]
              //
              if(!this.competencyLogic || !this.competencyLogic.message){
                // No Post Message set for current ancestor
                // get the parent message only if next move to C
                let preCId = this.getPreviousC()
                //a
                this.competencyLogic = this.competencyLogicMap[preCId]
              }
              if(!this.competencyLogic){
                  this.competencyLogic = {}
              }
              // Open Message
              if(this.competencyLogic && this.competencyLogic.message){
                  this.openComptencyLogicModal()
              }
          }
      }
    },
    getParentCompetencyId(parentId){
      for (var i = 0; i < this.linearTopics.length; i++) {
          if (this.linearTopics[i].uuid === parentId) {
            return this.linearTopics[i].competencies[0]
            break
          }
      }
      return ''
    },
    getPreviousC(){
      let parentType = 'MC'
      let nextCompetencyId = ''
      for (var i = 0; i < this.linearTopics.length; i++) {
          if (this.linearTopics[i].uuid === this.nextEntity.ancestor) {
            let nextParent = this.linearTopics[i]
            if(nextParent.ancestor === this.course.uuid){
                // the means the nextEntity Parent is C
                parentType = 'C'
                nextCompetencyId = nextParent.uuid
            }else{
                nextCompetencyId = getParentCompetencyId(nextParent.ancestor)
             }
            break
          }
      }

      for (var j = 0; j < this.linearTopics.length; j++) {
          if (this.linearTopics[j].uuid === this.entity.ancestor) {
              let currentParent = this.linearTopics[j]
              if(currentParent.ancestor === this.course.uuid){
                  return currentParent.competencies[0]
              }else{
                  for (var k = j - 1; k >= -1; k--) {
                    let currentGrandParent = this.linearTopics[k]
                    if(currentGrandParent.ancestor === this.course.uuid){
                      if(nextCompetencyId!==currentGrandParent) {
                        return currentGrandParent.competencies[0]
                      }
                    }
                  }
              }
            break
          }
      }
    },

    openComptencyLogicModal () {
        setTimeout(() => {
          this.$refs.logicModal.show()}, 500)
    },
    closeComptencyLogicModal () {
      this.$refs.logicModal.hide()
    },    msToTime (s) {
      var ms = s % 1000
      s = (s - ms) / 1000
      var secs = s % 60
      s = (s - secs) / 60
      var mins = s % 60
      var hrs = (s - mins) / 60
      return hrs + ' hrs ' + mins + ' mins ' + secs + ' seconds'
    },
		isPrintDisable () {
      if (this.enabledFeatures && this.enabledFeatures['disablePrint']) {
        return this.enabledFeatures['disablePrint'].enabled
      }
      return false
    },
    addPrintClass () {
      if (this.isPrintDisable()) {
        return 'no_print_win'
      } else {
        return ''
      }
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'entity': state => state.course.entity,
      'nextEntity': state => state.course.nextEntity,
      'linearTopics': state => state.course.linearTopics,
			'isTocOpen': state => state.course.isTocOpen,
			'enabledFeatures': state => state.institution.enabledFeatures,
      'entityActivity': state => state.course.entityActivity
    })
  },
  watch: {
    entityUuid (newId) {
      if (newId) {
        this.loadCourse()
      }
    }
  }
}
</script>

<style scoped>
.content{
  padding-top: 40px;
  margin-right: 30px;
  margin-left: 30px;
}

.course-nav{
  background:#e1e1e1;
  min-height: 500px;
}
.coure-nav-list-item{
  background:#e1e1e1;
  border: none;
}

.course-thumbnail{
  background:#f8f9fa;
  min-height: 500px;
}

.course-information{
  margin-top:20px;
}

.course-description{
  padding-top:20px;
  padding-left:20px;
  padding-right:20px;
}

.course-description-card{
  background:#f8f9fa;
  border-color: #f8f9fa;
}

.header-view {
  background: #ffeced!important;
}
.entity-nav, .header-view {
	min-height:60px;
	display: flex;
    align-items: center;
}
.entity-nav, .learning {
	background: #f8f9fa;
}
.pull-left{
  float:left;
}

.entity-title {
	margin-bottom: 0;
    font-size: 20px;
    margin-top: 2px;
    max-width: calc(100% - 57px);
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: robotoSlab_Light;
    min-height: auto;
    background: none;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
	-webkit-box-orient: vertical;
	position:relative;
	max-height:49px;
	padding-right:16px;
}

img {
	width:28px;
	height:26px;
}

.icon-asset {
    margin-right: 8px;
}

.description {
	margin-bottom: 5px;
}
.time_taken {
	margin-bottom: 20px;
    float: left;
}

</style>



// WEBPACK FOOTER //
// src/app/course/components/EntityResult.vue